import React from "react";
import { Route, Routes, Navigate, useParams } from "react-router-dom";
import LoaderData from "./LoaderData/LoaderData";
import { PrivateRouteApp, PrivateRouteBookingFolderInformations } from './PrivateRoute';
import LoginPage from './../pages/LoginPage/LoginPage';
import LoginPageSelfCheckin from '../pages/LoginPage/LoginPageSelfCheckin';
import Error404Page from './../pages/Error404Page/Error404Page';
import KonamiCode from './../components/Navigation/KonamiCode/KonamiCode';
import TitlePage from './../components/Page/TitlePage/TitlePage';

const MainRouter = (props) => {
    return (
        <div>
            <TitlePage test={props}/>
            <Routes
                atEnter={{ opacity: 0 }}
                atLeave={{ opacity: 0 }}
                atActive={{ opacity: 1 }}
                className="switch-wrapper"
            >
                { /**** PRECHECKIN ****/ }
                { /* <PrivateRoutePreCheckIn path="/:token/:lang/preCheckIn/:id" Component={LoaderData} /> */ }
                { /**** DETAIL DOSSIER ****/ }
                { /* <PrivateRouteBookingFolderInformations path="/:token/:lang/bookingFolderInformations/:id" Component={LoaderData} /> */ }

                { /**** LOGIN ****/ }
                <Route path="/:token/:lang/login/:passwordconfirm/" element={<LoginPage />} />
                <Route path="/:token/:lang/login" element={<LoginPage />} />
                <Route path="/:token/:lang/signIn" element={<LoginPage />} />

                { /**** SELFCHECKIN ****/ }
                { /* <Route path="/:token/:lang/selfCheckin" exact Component={LoginPageSelfCheckin} />
        <Route path="/:token" exact Component={LoginPageSelfCheckin} />*/ }

                <Route path="/:token/:lang/establishment" element={<PrivateRouteApp />} />
                <Route path="/:token/:lang/bookings" element={<PrivateRouteApp />} />
                <Route path="/:token/:lang/bookings/:id" element={<PrivateRouteApp />} />
                <Route path="/:token/:lang/bookingFolderInformations/:id" element={<PrivateRouteBookingFolderInformations />} />


                { /* <Route path="/:token/:lang/account/connectionAndSetting" element={PrivateRouteApp} exact Component={LoaderData} />
        <Route path="/:token/:lang/account/personalInformation" element={PrivateRouteApp} exact Component={LoaderData} />
        <Route path="/:token/:lang/account/addressCP" element={PrivateRouteApp} exact Component={LoaderData} />
        <Route path="/:token/:lang/account/additionalInformation" element={PrivateRouteApp} exact Component={LoaderData} />
        <Route path="/:token/:lang/account/deleteAccount" element={PrivateRouteApp} exact Component={LoaderData} />*/ }

                <Route path="/:token/:lang/account/:codePage" element={<PrivateRouteApp />} />
                <Route path="/:token/:lang/dashboard" element={<PrivateRouteApp />} />
                <Route path="/:token/:lang/" element={<PrivateRouteApp />} />

                <Route path="/:token/:lang/preCheckIn/:id" element={<PrivateRouteApp />} />
                <Route path="/:token/:lang/checkin/:id" element={<PrivateRouteApp />} />
                <Route path="/:token/:lang/checkin" element={<PrivateRouteApp />} />
                <Route path="/:token/:lang/checkinV2/:id" element={<PrivateRouteApp />} />

                { /*<Route path="*"  element={<Navigate to={`/${token}/${lang}/login`} />}  />*/}
                <Route path="*" element={<LoginPage />} />

                { /* <PrivateRouteApp path="/:token/:lang/establishment" exact component={LoaderData} />
        <PrivateRouteApp path="/:token/:lang/bookings" exact component={LoaderData} />
        <PrivateRouteApp path="/:token/:lang/bookings/:id" component={LoaderData} />
        <PrivateRouteApp path="/:token/:lang/account/connectionAndSetting" exact component={LoaderData} />
        <PrivateRouteApp path="/:token/:lang/account/personalInformation" exact component={LoaderData} />
        <PrivateRouteApp path="/:token/:lang/account/addressCP" exact component={LoaderData} />
        <PrivateRouteApp path="/:token/:lang/account/additionalInformation" exact component={LoaderData} />
        <PrivateRouteApp path="/:token/:lang/account/deleteAccount" exact component={LoaderData} />
        <PrivateRouteApp path="/:token/:lang/dashboard" exact component={LoaderData} />
        <PrivateRouteApp path="/:token/:lang/checkin/:id" exact component={LoaderData} />
        <PrivateRouteApp path="/:token/:lang/checkin" exact component={LoaderData} />
        <PrivateRouteApp path="/:token/:lang/checkinV2/:id" exact component={LoaderData} />
        <PrivateRouteApp path="/:token/:lang/" exact component={LoaderData} />
        <Route path="*" component={() => <Error404Page />} /> */ }
            </Routes>
            <KonamiCode />
        </div>
    );
}

export default MainRouter;
